import React from 'react'
import { Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { toast } from 'react-toastify'

import updateAzione from 'graphql/mutations/updateAzione'


let CloseButton = ({ closeToast, promemoria, updateAzione }) => {
  const dismissPromemoria = promemoria => event => {
    event.preventDefault()
    updateAzione({
      variables: {
        id: promemoria.id,
        azione: {
          promemoriaDismesso: true,
        },
      },
    })
    .then(({ data }) => {
      //console.log(data)
      closeToast()
    })
    .catch(error => {
      console.log(error.message)
    })
  }

  return (
    <a
      href="#"
      style={{ lineHeight: 1, fontSize: '20px', color: 'rgba(255, 255, 255, 0.7)', fontWeight: 700, display: 'table', padding: '0 5px' }}
      onClick={dismissPromemoria(promemoria)}
    >
      &times;
    </a>
  )
}
CloseButton = graphql(updateAzione, { name: 'updateAzione' })(CloseButton)


const Promemoria = ({ promemoria }) => {
  return (
    <div style={{ color: '#fff' }}>
      <p>{promemoria.descrizione}</p>
      <hr/>
      <Link to={`/clienti/${promemoria.clienteId}`} onClick={e => e.stopPropagation()} style={{ color: '#fff' }}>
        <span><b>{promemoria.cliente.nome}</b><br />
        Tel: {promemoria.cliente.telefono}</span>
      </Link>
    </div>
  )
}


class NotifichePromemoria extends React.Component {
  componentDidMount() {
    const { promemoria } = this.props

    toast.dismiss()

    setTimeout(() => {
      promemoria.forEach(p => {
        toast.info(<Promemoria promemoria={p} />, {
          closeButton: <CloseButton promemoria={p} />,
          //closeOnClick: false,
          autoClose: false
        })
      })
    }, 1000)
  }

  render() {
    return null
  }
}

export default NotifichePromemoria



// WEBPACK FOOTER //
// ./src/views/App/NotifichePromemoria.jsx